import type { IconSvgObject } from './types';

const BubbleChatBlockedIcon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.58569 3.58569C8.90461 2.89234 10.4065 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 13.5935 21.1077 15.0954 20.4143 16.4143M5.27419 5.29079C3.55991 7.00929 2.5 9.38087 2.5 12C2.5 13.0483 2.6698 14.057 2.98341 15C3.60922 16.8818 2.98894 19.1667 2.5 20C3.5 19.9125 5.5 19.5 7.5 20.3687C8.8394 21.0904 10.3719 21.5 12 21.5C14.6191 21.5 16.9907 20.4401 18.7092 18.7258", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BubbleChatBlockedIcon;
